import Loadable from '../../components/loadable';

const SignedWaiverQuestionnaire = Loadable({
  loader: () => import('../../pages/waivers/signing_waivers/signed_waiver_questionnaire'),
});

angular.module('shared').value('SignedWaiverQuestionnaire', SignedWaiverQuestionnaire);
